module.exports = __webpack_public_path__ + "img/1.6.b88bc75c.png";